import React from 'react';
import './Products.css';

import { Heading, Product } from '../../../components';
import { productsContent } from '../../../constants';
import { getPopular } from '../../../utils';



const Products = () => {

  // Get the top 8 popular products
  const popularProducts = getPopular(productsContent);
  const topProducts = popularProducts.slice(0, 8);

  return (
    <section className='products'>

      {/* Section heading */}
      <Heading title={'Popular Items'} subTitle={'Customer Favorites'} />

      <div className='box-container'>
        {
          // Map over the top products array to render each product
          topProducts.map((item) => {
            return (
              <Product key={item.id} product={item} />
            )
          })
        }
      </div>
    </section>
  )

}

export default Products;